<template>
  <el-dialog
    custom-class="import-dialog"
    title="添加可视化报表"
    :visible="visible"
    @close="close"
  >
    <div class="p20">
      <div class="table mb20">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          stripe
          border
          ref="brandTable"
          @current-change="handleCurrentChange"
          highlight-current-row
          @selection-change="getChecked"
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="reportName"
            label="报表名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="configId"
            label="报表configId"
          ></el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <div class="btn-wrapper mb20 flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      list: [],
      total: 0,
      placeholder: "请输入商品名",
      currentRow: {},
      tHeader: [],
      tBody: [],
      dialogVisible: false,
      importTempVisible: false,
      checkedRow: {},
      batchCondition: {
        oldWord: "",
        newWord: "",
        categoryId: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      searchCondition: {
        queryType: "spu_name"
      },
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    save() {
      if (!this.currentRow.id) {
        this.$message({
          type: "warning",
          message: "请先选择报表"
        });
      } else {
        this.$emit("saveHeMiaoVisualReport", this.currentRow);
      }
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    close() {
      this.$emit("close");
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    async queryList() {
      const { result } = await this.$store.dispatch(
        "querySavedHeMiaoVisualReport",
        {
          layoutType: "miniprogram",
          pageSize: this.pageSize,
          pageNo: this.currentPage
        }
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    }
  }
};
</script>
<style lang="scss" scoped></style>
